import PropTypes from 'prop-types';
import ValueCardCarouselProps from '~types/components/ValueCardCarouselProps';
import ValueCardFP from '../../../components/ValueCardFP/ValueCardFP';
import getStatementText from '../../../utils/getStatementText';
import './FPValueCardCarousel.scss';
import getLearnMoreContent from '../../../utils/getLearnMoreContent';
import getLearnMoreLinks from '../../../utils/getLearnMoreLinks';


const FPValueCardCarousel = (props: ValueCardCarouselProps) => {
  const {
    valueList,
    finalResults,
    cardClassName,
    setCardClassName,
  } = props;
  const displayLearnMoreButton = false;

  return (
    <div className="results-carousel-fp" data-testid="value-cards-fp">
        <ValueCardFP key="one"
          valueStatement={getStatementText(finalResults[0], valueList)}
          valueStatementId={finalResults[0]}
          learnMoreContent={getLearnMoreContent(finalResults[0], valueList)}
          learnMoreLinks={getLearnMoreLinks(finalResults[0], valueList)}
          rank={1}
          displayLearnMoreButton={displayLearnMoreButton}
          cardClassName={cardClassName}
          setCardClassName={setCardClassName}
        />

        <ValueCardFP key="two"
          valueStatement={getStatementText(finalResults[1], valueList)}
          valueStatementId={finalResults[1]}
          learnMoreContent={getLearnMoreContent(finalResults[1], valueList)}
          learnMoreLinks={getLearnMoreLinks(finalResults[1], valueList)}
          rank={2}
          displayLearnMoreButton={displayLearnMoreButton}
          cardClassName={cardClassName}
          setCardClassName={setCardClassName}
        />

        <ValueCardFP key="three"
          valueStatement={getStatementText(finalResults[2], valueList)}
          valueStatementId={finalResults[2]}
          learnMoreContent={getLearnMoreContent(finalResults[2], valueList)}
          learnMoreLinks={getLearnMoreLinks(finalResults[2], valueList)}
          rank={3}
          displayLearnMoreButton={displayLearnMoreButton}
          cardClassName={cardClassName}
          setCardClassName={setCardClassName}
        />
    </div>
  );
};

FPValueCardCarousel.defaultProps = {
  cardClassName: 'value-card-fp',
  setCardClassName: null,
};

FPValueCardCarousel.propTypes = {
  valueList: PropTypes.arrayOf(PropTypes.object).isRequired,
  finalResults: PropTypes.arrayOf(PropTypes.number).isRequired,
  cardClassName: PropTypes.string,
  setCardClassName: PropTypes.func,
};

export default FPValueCardCarousel;